import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData, getAllFilterData } from "../../Utility/API";
import { Button } from "react-bootstrap";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { Form } from "react-bootstrap";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { Modal } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { Col, Row, Container } from "react-bootstrap";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import UserTypeFilter from "./UserTypeFilter";
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const RedemTransaction = () => {
  const [pending, setPending] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState("");
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [playerTypeList, setPlayerTypeList] = useState([]);

  const [showPlayer, setShowPlayer] = useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");

  const [amount, setAmount] = useState("");

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getPlayerTypes = () => {
    let url = `${endPoints.api.playertypes}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          setPlayerTypeList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // api call
    let data = {
      userId: userId,
      status: "",
      name: name,
      userName: username,
      email: email,
    };
    fetchUserList(data);
    getPlayerTypes();
  }, []);

  const fetchUserList = async (data) => {
    let url = `${endPoints.api.USER_COIN_TRANSACTION}`;
    setIsLoading(true);

    await getAllFilterData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleOk = () => {
    // console.log("selectedRecord", selectedRecord);
    let data = {
      userId: selectedRecord.id_user,
      coinType: "sc_main",
      transferType: "Deposit",
      amount: amount,
      description: "admin deposit",
    };

    let url = endPoints.api.DEPOSIT_COIN;
    setIsLoading(true);
    addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          setAmount("");
          SuccesToast("Coins Added Succesfully");
          setShow(false);
          fetchUserList();
        } else {
          ErrorToast(response?.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  // Provider Filter
  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState("");

  const handleFilterChange = (name) => {
    const newFilterValue = name.toLowerCase();
    setFilterValue(newFilterValue);

    if (name === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter((item) =>
        item.userType.toLowerCase().includes(newFilterValue)
      );
     
      setFilteredRows(filteredData);
    }
   
  };
  console.log('filteredRows',filteredRows.length)
  const handleAccountTypeClose = (newValue) => {
    console.log('Player Type',newValue)
    setUserAccDialog(false);
    handleFilterChange(newValue)
  };
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const sortedRows = [...rows].sort((a, b) => {
    if (orderBy) {
      if (order === "asc") {
        return a[orderBy] < b[orderBy] ? -1 : 1;
      } else {
        return a[orderBy] > b[orderBy] ? -1 : 1;
      }
    }
    return 0;
  });

  //const rowsToDisplay = rows; //filterValue.length > 0 ? filteredRows :
  const rowsToDisplay = filterValue.length > 0 ? filteredRows : sortedRows;
  const radioGroupRef = useRef(null);
  const [value, setValue] = useState("");
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleUpdate = () => {
    let playerId = playerTypeList.filter((item) => item.player_type == value);
    console.log("playerId", playerId);
    let data = {
      idAccount: selectedRecord.id_account,
      fieldValue: playerId[0]?.id,
      userId: selectedRecord?.id_user,
      fieldName: "player_type",
    };
    UpdateCommonInfo(data);
  };
  const UpdateCommonInfo = (data) => {
    let url = `${endPoints.api.userFieldUpdate}`;
    setIsLoading(true);
    addData(url, data)
      .then((response) => {
        setIsLoading(false);

        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          setShowPlayer(false);
          let data = {
            userId: userId,
            status: "",
            name: name,
            userName: username,
            email: email,
          };
          fetchUserList(data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let data = {
        userId: userId,
        status: "",
        name: name,
        userName: username,
        email: email,
      };
      fetchUserList(data);
    }
  };
  const [userAccDialog, setUserAccDialog] = useState(false);

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="row">
                  <div
                    className="col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #444",
                    }}
                  >
                    <h3
                      className="mb-2 heading-table"
                      style={{ fontFamily: "ArticulatCF-Bold" }}
                    >
                      Redem Transaction
                    </h3>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <Row>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Customer ID</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Customer ID"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter First Name or Last Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Userrname</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Username"
                        value={username}
                        onChange={(e) => setuserName(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Email</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group
                      as={Col}
                      controlId="formName"
                      style={{ marginTop: "30px" }}
                    >
                      <Button
                        variant="primary"
                        style={{
                          width: "70%",
                          background: "#0D3862",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          let data = {
                            userId: userId,
                            status: "",
                            name: name,
                            userName: username,
                            email: email,
                          };
                          fetchUserList(data);
                        }}
                      >
                        Search
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <div className="table_search">
                  <TextField
                    style={{ marginBottom: "10px", width: "25%" }}
                    placeholder="Enter provider name..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div> */}
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                     
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">User ID</TableCell>
                            <TableCell align="center">Username</TableCell>

                            <TableCell align="center">Full Name</TableCell>
                            <TableCell align="center">Email </TableCell>
                            <TableCell align="center">Player Type </TableCell>
                            <TableCell align="center">
                         
                              <Button
                                variant="primary"
                                style={{
                                  // width: "70%",
                                  background: "#0D3862",
                                  borderRadius: "8px",
                              
                                }}
                                onClick={() => {setUserAccDialog(true)}}
                              >
                                 User Type
                              </Button>
                            </TableCell>
                            <TableCell
                              align="center"
                              onClick={() => handleSortRequest("totalDeposit")}
                            >
                              Total Deposit{" "}
                              {orderBy === "totalDeposit" ? (
                                order === "asc" ? (
                                  <ArrowUpward />
                                ) : (
                                  <ArrowDownward />
                                )
                              ) : (
                                <ArrowUpward />
                              )}
                            </TableCell>
                            <TableCell align="center">
                              Approved Redemption
                            </TableCell>
                            <TableCell align="center">
                              Pending Redemption{" "}
                            </TableCell>

                            <TableCell
                              align="center"
                              onClick={() =>
                                handleSortRequest("totalRedeemBalance")
                              }
                            >
                              Redeemable Balance
                              {orderBy === "totalRedeemBalance" ? (
                                order === "asc" ? (
                                  <ArrowUpward />
                                ) : (
                                  <ArrowDownward />
                                )
                              ) : (
                                <ArrowUpward />
                              )}
                            </TableCell>
                            <TableCell
                              align="center"
                              onClick={() => handleSortRequest("totalBalance")}
                            >
                              SC Balance{" "}
                              {orderBy === "totalBalance" ? (
                                order === "asc" ? (
                                  <ArrowUpward />
                                ) : (
                                  <ArrowDownward />
                                )
                              ) : (
                                <ArrowUpward />
                              )}
                            </TableCell>
                            <TableCell
                              align="center"
                              onClick={() =>
                                handleSortRequest("totalGcBalance")
                              }
                            >
                              GC Balance{" "}
                              {orderBy === "totalGcBalance" ? (
                                order === "asc" ? (
                                  <ArrowUpward />
                                ) : (
                                  <ArrowDownward />
                                )
                              ) : (
                                <ArrowUpward />
                              )}
                            </TableCell>

                            <TableCell align="center" style={{ widith: "30%" }}>
                              Option
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">
                                  {row.id_user}
                                </TableCell>
                                <TableCell align="center">
                                  {row.login}
                                </TableCell>
                                <TableCell align="center">
                                  {`${row.name}  ${row.surname}`}
                                </TableCell>
                                <TableCell align="center">
                                  {row.email}
                                </TableCell>
                                <TableCell align="center">
                                  {row.playerType}
                                </TableCell>
                                <TableCell align="center">
                                  {row.userType}
                                </TableCell>

                                <TableCell align="center">
                                  {row.totalDeposit.toFixed(2)}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalRedeem.toFixed(2)}
                                </TableCell>

                                <TableCell align="center">
                                  {row.totalRedeemPending.toFixed(2)}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalRedeemBalance.toFixed(2)}
                                </TableCell>

                                <TableCell align="center">
                                  {row.totalBalance.toFixed(2)}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalGcBalance.toFixed(2)}
                                </TableCell>

                                <TableCell align="center">
                                  <div style={{}}>
                                    <Button
                                      variant="primary"
                                      style={{
                                        background: "#04631e",
                                        borderColor: "#04631e",
                                        fontSize: " 12px",
                                      }}
                                      onClick={() => {
                                        setShow(true);
                                        setSelectedRecord(row);
                                      }}
                                    >
                                      Add Balance
                                    </Button>
                                    <Button
                                      variant="primary"
                                      style={{
                                        background: "#04631e",
                                        borderColor: "#04631e",
                                        fontSize: " 12px",
                                        marginTop: "10px",
                                      }}
                                      onClick={() => {
                                        setShowPlayer(true);
                                        setValue(row.playerType);
                                        setSelectedRecord(row);
                                      }}
                                    >
                                      Player Type
                                    </Button>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <UserTypeFilter
                    keepMounted
                    open={userAccDialog}
                    onClose={handleAccountTypeClose}
                    // value={userAccValue}
                  />
                  <>
                    <Modal
                      show={show}
                      onHide={() => {
                        setAmount("");
                        setShow(false);
                      }}
                      style={{ marginTop: "10%" }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Add Redemable Coin
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="enterCoin">
                              <Form.Label>Enter Coin</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="xxxxx"
                                value={amount}
                                onChange={(event) => {
                                  setAmount(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          disabled={amount == "" ? true : false}
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Add Balance
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={showPlayer}
                      onHide={() => {
                        setAmount("");
                        setShowPlayer(false);
                      }}
                      style={{ marginTop: "10%" }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Update Player Type
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <RadioGroup
                              ref={radioGroupRef}
                              aria-label="ringtone"
                              name="ringtone"
                              value={value}
                              onChange={handleChange}
                            >
                              {playerTypeList?.map((option) => (
                                <FormControlLabel
                                  value={option.player_type}
                                  key={option.id}
                                  control={<Radio />}
                                  label={option.player_type}
                                />
                              ))}
                            </RadioGroup>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleUpdate}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Update
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedemTransaction;
